import axios from 'axios';
import { useEffect, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { useParams } from 'react-router-dom';
import PageLoader from '../../components/global/loader/PageLoader';
import { InternalBanner } from '../../components/internals/InternalBanner';
import jQuery from 'jquery';

import './styles.scss';
import { SingleInternalBanner } from '../../components/internals/SingleInternalBanner';
export const SingleBlog = () => {
    const { slug } = useParams();
    const [pageContent, setPageContent] = useState(null);
    const [isFetching, setIsFetching] = useState(true);
    const [author, setAuthor] = useState(null);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [categories, setCategories] = useState([]);
    useEffect(() => {
        document.title = "Alinea Law PLLC";
        fetchPageContet(slug);
    }, [slug]);

    
    const fetchPageContet = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=fetch_single_blog_by_slug&slug=${slug}`);
            console.log(data);
            if (data?.post) {                
                if (data?.yoast_title?.length > 0) {
                    const finalTitle = data.yoast_title
                        .replace("%%title%%", data?.page?.post_title ? data?.page?.post_title : '')
                        .replace("%%page%%", "")
                        .replace("%%sep%%", "-")
                        .replace("%%sitename%%", "Alinea Law PLLC")

                    document.title = finalTitle;
                } else {
                    document.title = data?.post?.post_title ? `${data?.post?.post_title} - Alinea Law PLLC` : "Alinea Law PLLC";
                }

                console.log(document.title)
                if (document.querySelector('#wp-admin-bar-edit a')) {
                    document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Post`;
                    document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.post?.ID}&action=edit`;
                }
            }

            setPageContent(data?.post ?? null);
            setAuthor(data?.author ?? null);
            setCategories(data?.categories ?? []);
            setFeaturedImage(data?.featured_image ?? null);

            setTimeout(() => {
                jQuery("#table-of-contents").html("");
                var toc = jQuery("#table-of-contents");
                var lastLevel = 2; // Assuming the first heading level is H2
                let count = 0;
                jQuery("article h2, article h3").each(function(index) {
                    count ++;
                    var heading = jQuery(this);
                    var headingText = heading.text();

                    var anchor = headingText.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/\s+/g, '-').toLowerCase();
                    heading.attr('id', anchor);
                    var level = parseInt(this.tagName.substring(1));
                    
                    if (level > lastLevel) {
                        // Start a new sublist
                        var sublist = jQuery("<ul>");
                        toc.find('li:last').append(sublist);
                        toc = sublist;
                    } else if (level < lastLevel) {
                        // End current sublist(s)
                        toc = toc.parents('ul').last();
                    }
                    
                    lastLevel = level;
                    if (anchor?.length > 1) {
                        var listItem = jQuery('<li>').appendTo(toc);
                        listItem.append(jQuery('<a>').attr('href', '#' + anchor).text(headingText));
                    }
                });

                if (count < 1) {
                    jQuery("#table-of-contents").html("<li className='no-contents'>No Contents</li>");
                    jQuery("#table-of-contents").addClass('no-contents');
                }

                jQuery('#table-of-contents a').on('click', function (e) {
                    let elementId = jQuery(this).attr('href');

                    var elementTop = jQuery(elementId).offset()?.top ?? 0;
                    var viewportHeight = jQuery(window).height();
                    var newScrollTop = elementTop - (viewportHeight / 2);
                  
                    window.scrollTo({ top: newScrollTop, behavior: 'smooth' })
                    e.stopPropagation();
                    return false;
                  });
            }, 600);

            window.addEventListener('scroll', highlightActiveItem);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }


    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    const highlightActiveItem = () => {
        var headings = jQuery("h2, h3");
        var tocLinks = jQuery("#table-of-contents a");
        
        headings.each(function(index) {
            if (isElementInViewport(this)) {
                tocLinks.removeClass("active");
                var currentAnchor = jQuery(this).attr("id");
                tocLinks.filter("[href='#" + currentAnchor + "']").addClass("active");
            }
        });
    }



    return <Fade delay={1}>
        <main id='main' className="internal-page single">
            {!isFetching && <>
                <SingleInternalBanner page={pageContent} author={author} categories={categories} />
                {/* <InternalBanner page={pageContent} /> */}
                <section id="main-article-content">
                    <div className="container">
                        <div className="inner-sidebar-page-wrapper">
                            <article dangerouslySetInnerHTML={{__html: pageContent?.post_content }}></article>
                            <aside>
                                {
                                    featuredImage && <div className='featured-image' dangerouslySetInnerHTML={{__html: featuredImage}} />
                                }
                                <div className='toc-wrapper'>
                                    <span className='title'>Page Contents</span>
                                    <ul id="table-of-contents">
                                        
                                    </ul> 
                                </div>
                            </aside>
                        </div>
                    </div>
                </section>
            </>}
            {
                isFetching && <PageLoader />
            }
        </main>
    </Fade>
}